import { ReferFriendContainer } from 'src/containers';

export const ReferFriend = () => <ReferFriendContainer />;
